<template>
  <section>
    <div class="section_title"><h1>ショッピングガイド</h1></div>

    <ul class="list-dot-01 mt-5 guide-contents">
      <li><a class=""  @click="scrollToAnchorPoint('guide-knowledge')">商品ご購入時に必要なこと</a></li>
      <li><a class=""  @click="scrollToAnchorPoint('guide-howto')">商品のご注文方法</a></li>
      <li><a class=""  @click="scrollToAnchorPoint('guide-payment')">代金の支払方法</a></li>
      <li><a class=""  @click="scrollToAnchorPoint('guide-delivery')">配送について</a></li>
      <li><a class=""  @click="scrollToAnchorPoint('guide-postage')">送料について</a></li>
      <li><a class=""  @click="scrollToAnchorPoint('guide-return')">返品について</a></li>
      <li><a class=""  @click="scrollToAnchorPoint('guide-point')">ポイントについて</a></li>
    </ul>

    <h3  ref="guide-knowledge" class="ttl-cmn-03 mt-5 pt-5">商品ご購入時に必要なこと</h3>
    <p class="txt-cmn-01">※ご注文の際には下記をご準備ください。</p>
    <ul class="list-dot-01">
      <li>お名前と会員番号</li>
      <li>配送先住所と電話番号</li>
      <li>商品名または商品コード</li>
      <li>購入個数</li>
      <li>配達日・配達時間の指定</li>
      <li>支払方法</li>
    </ul>
    <h3 ref="guide-howto" class="ttl-cmn-03 mt-5 pt-5">商品のご注文方法</h3>
    <ol class="list-dec-01 txt-cmn-01">
      <li>オンラインショップ（会員サイト、MSCアプリ）</li>
      <li>電話</li>
      <li>FAX</li>
      <li>銀座ビューティサロン マナビス&amp;ボワール</li>
    </ol>
    <ol class="list-dec-01 txt-cmn-01">
      <li class="txt-cmn-01">会員サイト
        <p>URL：<router-link to="/products">https://www.manavis-cosme.co.jp/web/#/products</router-link></p></li>
      <li class="txt-cmn-01">電話
        <p>【受注専用フリーコール】0800-222-0510<br>通話料無料<br>受付：9:00～16:00 （土日祝日・年末年始を除く）</p></li>
      <li class="txt-cmn-01">FAX
        <p>【受注専用FAX】0120-269-510<br>通信料無料</p></li>
      <li class="txt-cmn-01">銀座ビューティサロン&nbsp;マナビス&amp;ボワール
        <p class="txt-cmn-01">公式サイト：<a href="https://www.manavis-cosme.co.jp/salon/">https://www.manavis-cosme.co.jp/salon/</a></p>
        <p class="txt-cmn-01">〒104-0061&nbsp;東京都中央区銀座3-2-11<br>GINZA SALONE 7F</p>
        <p class="txt-cmn-01">東京メトロ丸の内線・銀座線&nbsp;「銀座」駅C8出口より徒歩30秒<br>東京メトロ有楽町線&nbsp;「銀座一丁目」駅4番出口より徒歩3分<br>JR山手線&nbsp;「有楽町」駅中央口より徒歩4分</p>
        <p class="txt-cmn-01">営業日：月曜日〜金曜日<br>営業時間：10:00〜18:00</p>
        <p>MANAVISサロン専用電話&nbsp;TEL&nbsp;03-6263-2496</p></li>
    </ol>
    <h3 ref="guide-payment" class="ttl-cmn-03 mt-5 pt-5">代金の支払い方法</h3>
    <ol class="list-dec-01 txt-cmn-01">
      <li class="txt-cmn-01">代金引換
        <p>※代金手数料として300円が商品代金に加算されます。</p></li>
      <li class="txt-cmn-01">銀行振込
        <p>※ご注文の前に商品代金を当社指定銀行預金口座に振込んでご注文をしてください。お振込みの際は、必ず会員ご本人様の名義にてお振込みください。なお、振込手数料は会員ご負担になります。<br>※入金確認後の発送になります。</p></li>
      <li class="txt-cmn-01">クレジットカード
        <p>※クレジットカードでのご購入は1回払いのみとなります。ローンでのご購入はできません。<br>※ご本人様名義のクレジットカードをご利用ください。</p></li>
    </ol>
    <h3 ref="guide-delivery" class="ttl-cmn-03 mt-5 pt-5">配送について</h3>
    <p>営業日の16:00までに受付されたご注文分については原則として宅配便により当日出荷、営業日16:00時以降もしくは土日祝日に到着したご注文分は翌営業日出荷となります。<br>ただし、初回ご注文の場合は、入会審査などの手続き上、ご注文受付日の翌営業日以降の出荷となることがあります。</p>
    <h3 ref="guide-postage" class="ttl-cmn-03 mt-5 pt-5">送料について</h3>
    <p>1回のご注文（ツール品を含む）で1万円（税込）以上の場合、無料です。<br>1万円未満の場合は全国一律700円の配送費をいただきます。</p>
    <h3 ref="guide-return" class="ttl-cmn-03 mt-5 pt-5">返品について</h3>
    <ol class="list-dec-01 txt-cmn-01">
      <li class="txt-cmn-01">商品不良による交換
        <p>商品に不良が発見され交換を希望される場合は、会員サポート営業部（フリーコール:0120-268-510）に連絡してください。</p></li>
      <li class="txt-cmn-01">クーリング・オフに伴う返品
        <p>会員マニュアル<a href="https://docs.google.com/viewer?url=https://www.manavis-cosme.co.jp//web/contents/information/img/211101_member_manual.pdf">第4項(1)クーリング・オフ</a>をご覧ください。</p></li>
      <li class="txt-cmn-01">退会に伴う返品
        <p>会員登録から1年以内に退会する場合、未開封品を返品することができます。当該返品商品について支払済の商品代金を返金します。<br>解約申込後5日以内に返品商品をご返送ください。なお、返品の際の送料は会員ご本人の負担となります。</p></li>
      <li class="txt-cmn-01">その他会員都合の返品
        <p>会員マニュアル<a href="https://docs.google.com/viewer?url=https://www.manavis-cosme.co.jp//web/contents/information/img/211101_member_manual.pdf">第4項(2)返品③その他会員都合の返品</a>をご覧ください。</p></li>
    </ol>
    <h3 ref="guide-point" class="ttl-cmn-03 mt-5 pt-5">ポイントについて</h3>
    <ol class="list-dec-01 txt-cmn-01">
      <li class="txt-cmn-01">各商品ごとに設定されたポイントを付与させていただきます。</li>
      <li class="txt-cmn-01">貯まったポイントは使用時に1ポイント＝1円として商品及びツール品のご購入にご使用していただけます。</li>
      <li class="txt-cmn-01">エコポイントは、エコ対象商品をご購入していただく事で付与させていただきます。</li>
    </ol>
  </section>
</template>

<style scoped>
.guide-contents li a {
  cursor: pointer;
}
</style>


<script>
export default {
  mounted() {
    window.scroll(0, 0);
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
  },
};
</script>
